var FinalizationRegistryLocal = typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry;
export { FinalizationRegistryLocal as FinalizationRegistry };
//# sourceMappingURL=FinalizationRegistryWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/es/utils/FinalizationRegistryWrapper.js
// module id = 156
// module chunks = 1